import { Url } from '@wix/da-url';
import { useSelector } from 'react-redux';
import { BiData, RedirectToLoginBiEvent, SubmitButtonClickBiEvent } from '@wix/da-bi/pkg/events';
import { Props as BaseButtonProps } from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { ReferralType } from '@wix/da-bi/pkg/constants';

export type UseSubmitButtonPropsProps = {
  /** deviation tags that will be pre-filled in the submit form */
  tags?: string | string[];
  biSectionname?: string;
  sendAnonToJoin?: boolean;
};

export type SubmitButtonProps = Pick<BaseButtonProps, 'onClick' | 'href' | 'biData'>;

/** Return the href, biData, and onClick required for a submit button (verification handled) */
export default function useSubmitButtonProps(
  { tags, biSectionname = 'general', sendAnonToJoin } = {} as UseSubmitButtonPropsProps
): SubmitButtonProps {
  const isLoggedIn = useSelector(getIsLoggedIn);

  const url = Url.buildFromPath('/studio');
  const params = new URLSearchParams();
  params.append('new', '1');
  if (tags) {
    const tagsAsParam = Array.isArray(tags) ? tags.join(',') : tags;
    params.append('tags', tagsAsParam);
  }

  const qs = params.toString();
  const studioHref = `${url}${qs ? `?${qs}` : ''}`;

  if (!isLoggedIn && sendAnonToJoin) {
    const homeUrl = Url.buildFromPath('/');
    const joinUrl = new URL(Url.joinLink('homepage_submit', studioHref));
    joinUrl.searchParams.set('cancel', homeUrl);
    const href = joinUrl.toString();
    const biData = BiData<RedirectToLoginBiEvent>({
      evid: 240,
      referral_info: ReferralType.SUBMIT,
    });
    return {
      href,
      biData,
    };
  }

  const href = studioHref;

  const biData = BiData<SubmitButtonClickBiEvent>({
    evid: 704,
    sectionname: biSectionname,
  });

  return {
    href,
    biData,
  };
}
